//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import {Dialog} from 'vant';
import {checkIdCard, getBirthdayAndSex} from '../certificate/cert'
import MemberExtend from "../certificate/member-extend";
import app from "../../store/modules/app";
import {StartUp, StartUpWithVm} from '@/lib/startup';

Vue.use(Dialog);

export default {
  name: "delivery-owner",
  components: {MemberExtend},
  data() {
    return {
      saving: false,
      member: {cardType: -1, memberExtend: {}},
      content: '获取验证码',
      canClick: true,
      totalTime: 30,
      codeing: false,
      cardTypeStr: '居民身份证',
      show: false,
      actions: [
        {name: '居民身份证'},
        {name: '护照'},
        {name: '军官证'},
        {name: '营业执照'}
      ],
      planId: 0

    }
  },
  methods: {
    onSave() {


      // return;
      if (!this.member.name) {
        this.$toast('请输入姓名');
        return;
      }

      this.cardType(this.cardTypeStr);
      if (this.member.cardType < 0) {
        this.$toast('请选择证件类型');
        return;
      }
      if (!this.member.cardNum) {
        this.$toast('请输入证件号');
        return;
      }
      if (this.member.cardType === 0) {
        if (!checkIdCard(this.member.cardNum)) {
          this.$toast('身份证号填写有误');
          return;
        } else {
          const info = getBirthdayAndSex(this.member.cardNum);
          console.log(info)
          this.member.birthday = info.birthDay;
          //  0代表女性，不为0代表男性
          this.member.gender = info.sex === 0 ? 2 : 1;
        }
      }

      if (!/^1[23456789]\d{9}$/.test(this.member.buyHousePhoneNumber)) {
        this.$toast('购房手机号格式无效!');
        return;
      }
      if (!/^1[23456789]\d{9}$/.test(this.member.phoneNumber)) {
        this.$toast('手机号格式无效');
        return;
      }
      if (!/^\d{6}$/.test(this.member.code)) {
        this.$toast('请输入6位数字验证码');
        return;
      }
      this.member.loginProvider = "Weixin";
      // console.log(this.member)
      // return;
      this.saving = true;
      const vm = this;
      abp.ajax.post('/api/services/app/Member/OwnerCertification', this.member).then(res => {
        this.$toast("认证成功");

        abp.auth.clearToken();
        StartUp().then(() => {
          abp.initial = false;
          console.log('login again')
          // let planId = localStorage.getItem('PlanId')

          vm.$router.replace({
            path: '/delivery/' + this.planId,
            // params: parseInt(planId),
            // query: {returnUrl: '/delivery/' + planId}
          });
        });


      }).catch(error => {
        if (error.response.status === 500) {
          console.log(error.response.data.error);
          var err = {};
          err = error.response.data.error;
          if (err.message === "认证失败") {
            this.showContact()
          }
        }

      }).finally(() => {
        this.saving = false;
      });
    },
    countDown() {
      if (!this.canClick) return;
      this.canClick = false;
      this.content = this.totalTime + 's后重新发送';
      let clock = window.setInterval(() => {
        this.totalTime--;
        this.content = this.totalTime + 's后重新发送';
        if (this.totalTime < 0) {
          window.clearInterval(clock);
          this.content = '重新发送验证码';
          this.totalTime = 30;
          this.canClick = true;
        }
      }, 1000)
    },

    getVerificationCode() {
      if (!/^1[23456789]\d{9}$/.test(this.member.phoneNumber)) {
        this.$toast('手机号格式无效');
        return;
      }
      let params = {
        address: this.member.phoneNumber
      };
      this.codeing = true;
      abp.ajax.post('/api/services/app/Verification/SendVerificationCode', params).then(res => {
        this.$toast.success('发送成功');
        this.countDown();
      }).finally(() => {
        this.codeing = false;
      })
    },
    onCancel() {
      this.show = false;
    },
    onSelect(item) {
      this.cardTypeStr = item.name;
      this.cardType(item.name);
      this.show = false;
    },
    cardType(name) {
      if (name === '居民身份证') {
        this.member.cardType = 0;
      } else if (name === '护照') {
        this.member.cardType = 1;
      } else if (name === '军官证') {
        this.member.cardType = 2;
      } else if (name === '营业执照') {
        this.member.cardType = 3;
      }
    },
    showContact() {
      Dialog.confirm({
        title: '温馨提醒',
        message: '业主名下无房产信息，' + '<br/>' + '请联系客服400-012-7878 ',
        confirmButtonText: '联系客服'
      }).then(() => {
        // on confirm
        window.location.href = 'tel://400-012-7878'
      }).catch(() => {
        // on cancel
      });
    },
    handleMemberExtend(data) {
      this.member.memberExtend = data;
    }

  },
  created() {
    this.planId = parseInt(this.$route.params.deliveryPlanId) || 0;
  }
}
